export default __webpack_public_path__ + "static/media/curved0.d146ec6e.jpg";